import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { IOnlinePublicationMessages } from '../../../../../types';
import { ImageUploader } from '../../../../common/components/ImageUploader';
import { LOGO_REQUIREMENTS, MAX_LOGO_FILE_SIZE } from '../../../../constants';

import { IMAGE_PREVIEW_CLASS, styles } from './PublicationLogoUpload.styles';

export type IPublicationLogoUploadProps = {
  entitySubdomain: string;
  messages: IOnlinePublicationMessages;
  logoUrl: string | null;
  onUrlChange(newValue: string | null): any;
};

export const PublicationLogoUpload = (props: IPublicationLogoUploadProps) => {
  const { entitySubdomain, logoUrl, messages, onUrlChange } = props;
  return (
    <Box sx={styles.container} data-test="publication-logo-upload">
      <Box sx={styles.headerContainer}>
        <Typography variant="subtitle1">{messages.logo}</Typography>
        <Typography variant="body2" color="text.secondary">
          {messages.logoDescription}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {messages.logoRequirements(LOGO_REQUIREMENTS)}
        </Typography>
      </Box>
      <ImageUploader
        entitySubdomain={entitySubdomain}
        maxSize={MAX_LOGO_FILE_SIZE}
        url={logoUrl ?? undefined}
        // imagePreviewClassName is a plain CSS class — rule lives in ovid.scss (.publication-logo-image-preview)
        imagePreviewClassName={IMAGE_PREVIEW_CLASS}
        style={{ maxWidth: 436 }}
        onUploadSuccess={onUrlChange}
        requireConfirmationBeforeRemove={true}
        confirmationModalProps={{ title: messages.removeLogo, description: messages.removeLogoResult }}
        onRemove={() => onUrlChange(null)}
      />
    </Box>
  );
};
